module.exports = __webpack_public_path__ + "static/img/SUZUKI.64e7731.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/SUZUKI.png
// module id = CyLf
// module chunks = 1